/** @jsx h */
import { h } from 'preact'
import getComponent from '../utils/get-component'
import Icon from './icon'

const sizeClasses = {
  small: 'f6 pv1 ph2',
  medium: 'f5 pv2 ph3',
  large: 'f3 pv3 ph4',
  huge: 'f3 pv3 ph4 w-100 w-50-ns',
  smallIcon: 'f6 pv1 pl1 pr2',
  mediumIcon: 'f5 pv2 pl2 pr3',
  largeIcon: 'f3 pv3 pl3 pr4',
  hugeIcon: 'f3 pv3 pl3 pr4 w-100 w-50-ns'
}
const colorClasses = {
  gray: 'not-allowed bg-light-gray white',
  green: 'pointer bg-green dim b--green white',
  white: 'pointer bg-white dim b--white gray',
  red: 'pointer bg-red dim b--red white',
  greenOutline:
    'pointer bg-transparent b--green green hover-bg-green hover-white',
  whiteOutline: 'pointer bg-transparent b--white white hover-bg-white',
  redOutline: 'pointer bg-transparent b--red red hover-bg-red hover-white'
}
const getClasses = (size, color, outline, icon) => {
  const colorKey = outline ? `${color}Outline` : color
  const sizeKey = icon ? `${size}Icon` : size
  return `${sizeClasses[sizeKey]} ${colorClasses[colorKey]}`
}

const getIconSize = size =>
  ({
    small: 16,
    medium: 20,
    large: 24
  }[size])

export default getComponent(
  'ba link tc nowrap',
  {
    tagName: 'button',
    color: 'green',
    size: 'medium',
    outline: false,
    empty: false,
    href: null,
    disabled: false,
    icon: ''
  },
  (
    { href, size, color, outline, tagName, empty, disabled, icon },
    { children }
  ) => ({
    className: `${getClasses(
      size,
      disabled ? 'gray' : color,
      outline || empty,
      icon
    )}${href ? ' dib' : ''}`,
    href,
    tagName: href ? 'a' : tagName,
    disabled,
    children: icon
      ? [
        <div className='flex items-center'>
          {[
            <Icon icon={icon} className='pr1' size={getIconSize(size)} />
          ].concat(children)}
        </div>
      ]
      : children
  })
)
